import React from "react";
import RadioOption from "./RadioOption";
import "./SubstituteSelector.scss";

/**
 * Reusable radio group component
 * @param {string} name - Radio group name
 * @param {string|number} selectedValue - Currently selected value
 * @param {function} onSelectionChange - Change handler
 * @param {Array} options - Array of {value, label} objects
 */
const RadioGroup = ({ name, selectedValue, onSelectionChange, options }) => {
  return (
    <div className="sss-radio-group">
      {options.map((option) => (
        <RadioOption
          key={option.value}
          name={name}
          value={option.value}
          checkedValue={selectedValue}
          onChange={onSelectionChange}
        >
          {option.label}
        </RadioOption>
      ))}
    </div>
  );
};

export default RadioGroup;


